<script>
  export let config, selectedDate

  import { onMount, createEventDispatcher } from 'svelte'

  import Moment from 'moment'
  import { getNotificationsContext } from 'svelte-notifications'
  import Menu from '$comps/context_menu/Menu.svelte'
  import MenuOption from '$comps/context_menu/MenuOption.svelte'
  import MenuDivider from '$comps/context_menu/MenuDivider.svelte'
  
  import Icon from 'svelte-icon'
  import reload from '$assets/svg/reload.svg'

  import { rerunConfig } from '$services/api.js'

  const dispatch = createEventDispatcher()
  const { addNotification } = getNotificationsContext()

  let running = false
  let thisCmp
  let showMenu = false
  let pos = {x: 0, y: 0}

  function rerun (mode) {
    running = true
    rerunConfig(config, selectedDate, mode).then(res => {
      running = false
      dispatch('reload', {})
      
      addNotification({
	text: `Config "${config.metadatas.name}" relaunched for ${selectedDate}`,
	type: 'success',
	position: 'bottom-right',
      })
      
    }).catch(err => {
      addNotification({
	text: `Failed to relaunch "${config.metadatas.name}" for ${selectedDate}`,
	type: 'error',
	position: 'bottom-right',
      })
    })
  }

  function rerun00Z () {
    rerun('00Z')
  }


  function rerun12Z () {
    rerun('12Z')
  }


  function rerunAna () {
    rerun('ANA')
  }
  
  function getStatusClass () {
    let classStr
    if (config.metadatas.kind.includes('ana')) classStr = `status-ana-${config.status['ana']}`
    if (config.metadatas.kind.includes('forecast')) classStr = `status-00Z-${config.status['00Z']} status-12Z-${config.status['12Z']}`
    return classStr
  }

  function getStatusStr () {
    let statusStr = ''
    if (config.metadatas.kind.includes('ana')) {
      if (config.done && config.done['ana']) {
	statusStr = `done at ${config.done['ana']}`
      } else if (config.due && config.due['ana']) {
	statusStr = `due for ${config.due['ana']}`
      }
      
    } else if (config.metadatas.kind.includes('forecast')) {
      if (config.done && config.done['00Z']) {
	statusStr = `done at ${config.done['00Z']}`
      } else if (config.due && config.due['00Z']) {
	statusStr = `due for ${config.due['00Z']}`
      }
      
    }

    if (statusStr === '') statusStr = 'no due date yet'
    
    return statusStr
  }

  function getStrokeColor (kind) { 
    const COLORS = {
      accent:  '#0f62fe',
      info:    '#1192e8',
      success: '#24a148',
      warning: '#f1c21b',
      error:   '#fa4d56',
      ignored: '#BA68C8',
    }
    return {
      'OK': COLORS.success, 'NOK': COLORS.error, 'PND': COLORS.info, 'WRN': COLORS.warning, 'IGN': COLORS.ignored
    }[config.status[kind]]
  }

  function viewPoints () {
    showMenu = false
    dispatch('openPointsViewer', { config: config })
  }

  function onRightClick (evt) {
    showMenu = true
    let size = thisCmp.getBoundingClientRect()
    pos = {x: evt.layerX, y: evt.layerY}
  }  
</script>

<main class="config-tile {getStatusClass()}" on:contextmenu|preventDefault="{onRightClick}" bind:this={thisCmp}>
  {#if showMenu}
    <Menu {...pos} on:click={viewPoints} on:clickoutside={() => showMenu = false}>
      <MenuOption text="View points for {config.metadatas.name}" />
      <MenuDivider />
      {#if config.metadatas.kind.includes('forecast')}
	<MenuOption text="Relaunch 00Z" on:click={rerun00Z} />
	<MenuOption text="Relaunch 12Z" on:click={rerun12Z} />
      {:else}
	<MenuOption text="Relaunch" on:click={rerunAna} />
      {/if}
    </Menu>
  {/if}
  
  <div class="config-tile-infos">
    <div class="name">
      <div class="label">Name</div>
      <div class="value">{config.metadatas.name}</div>
    </div>
    <div class="client">
      <div class="label">Client</div>
      <div class="value">{config.metadatas.client_name}</div>
    </div>
    
    {#if config.metadatas.kind.includes('forecast')}

        {#if config.metadatas.runs.includes('00Z')}
	<div class="actions">
	  <div class="label">00Z</div>
	  <div class="value">
            <button class="clear" disabled={running} on:click={rerun00Z} >
              <Icon class="btn-icon icon {running ? 'running' : ''}"
		    data={reload} fill="#00000000"
		    stroke={getStrokeColor('00Z')} size="30px" />
            </button>
	  </div>
	</div>
        {/if}

        {#if config.metadatas.runs.includes('12Z')}
	<div class="actions">      
	  <div class="label">12Z</div>
	  <div class="value">
            <button class="clear" disabled={running} on:click={rerun12Z} >
              <Icon class="btn-icon icon {running ? 'running' : ''}"
		    data={reload} fill="#00000000"
		    stroke={getStrokeColor('12Z')} size="30px" />
            </button>
	  </div>
	</div>
	{/if}
	
      {:else}
	
	  <div class="actions">      
	    <div class="label">Ana</div>
	    <div class="value">
              <button class="clear" disabled={running} on:click={rerunAna} >
		<Icon class="btn-icon icon {running ? 'running' : ''}"
		      data={reload} fill="#00000000"
		      stroke={getStrokeColor('ana')} size="30px" />
              </button>
	    </div>
	  </div>
	  
	{/if}

      </div>

  <div id="bottom-line">
    <div class="manual">
      {#if config.metadatas.kind.includes('custom') && config.metadatas.manual}
	(manual)
      {/if}
    </div>
    <div class="due-date">{ getStatusStr() }</div>
  </div>
</main>

<style lang="scss">
  @import "src/variables.scss";
  
  
  .config-tile {
    background-color: $gray9;
    width: 100%;

    @media (min-width: 2000px) {
      width: 30%;
    }

    &.type-forecast {
      border-right: 2px solid blue;
      border-bottom: 2px solid blue;
    }
    
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid $gray9;
    
    .config-tile-infos {
      display: flex;
      justify-content: space-between;
    }
    
    .name {
      width: 50%;
    }
    
    .client {
      width: 30%;
    }
    
    .label {
      @include serif;
      
      font-size: .9em;
      color: $gray3;
      padding-bottom: 5px;
    }
    
    .value {
      height: 30px;
      display: flex;
      align-items: center;
    }

    #bottom-line {
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      
      .manual {
	text-align: left;
	color: $gray5;
	font-size: .8em;
	font-style: italic;
      }
      
      .due-date {
	text-align: right;
	color: $gray5;
	font-size: .8em;
	font-style: italic;
      }
    }

    #context-menu {
      /* background-color: $gray8; */
      background-color: red;
      padding: 10px;
      padding-right: 20px;
      box-shadow: 5px 5px 5px rgba(0, 0, 0, .5);
      z-index: 10000000;
      position: absolute !important;
    }
  }

  :global(.running) {
    animation: rotate;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .status-ana-OK {
    border: 2px solid $success;
  }

  .status-ana-NOK {
    border: 2px solid $error;
  }

  .status-ana-PND {
    border: 2px solid $info;
  }

  .status-ana-WRN {
    border: 2px solid $warning;
  }

  .status-ana-NONE {
    border: 2px solid $gray7;
  }

  .status-ana-IGN {
    border: 2px solid $accent2;
  }


  .status-00Z-OK {
    border-top: 2px solid $success;
    border-left: 2px solid $success;
  }

  .status-00Z-NOK {
    border-top: 2px solid $error;
    border-left: 2px solid $error;
  }

  .status-00Z-PND {
    border-top: 2px solid $info;
    border-left: 2px solid $info;
  }

  .status-00Z-WRN {
    border-top: 2px solid $warning;
    border-left: 2px solid $warning;
  }
  
  .status-00Z-NONE {
    border-right: 2px solid $gray7;
    border-bottom: 2px solid $gray7;
  }

  .status-00Z-IGN {
    border-top: 2px solid $accent2;
    border-left: 2px solid $accent2;
  }


  .status-12Z-OK {
    border-right: 2px solid $success;
    border-bottom: 2px solid $success;
  }

  .status-12Z-NOK {
    border-right: 2px solid $error;
    border-bottom: 2px solid $error;
  }

  .status-12Z-PND {
    border-right: 2px solid $info;
    border-bottom: 2px solid $info;
  }

  .status-12Z-WRN {
    border-right: 2px solid $warning;
    border-bottom: 2px solid $warning;
  }
  
  .status-12Z-NONE {
    border-right: 2px solid $gray7;
    border-bottom: 2px solid $gray7;
  }

  .status-12Z-IGN {
    border-right: 2px solid $accent2;
    border-bottom: 2px solid $accent2;
  }
  
</style>
